<template>
  <div id="app">
    <Header msg="VueJS Panorama Viewer" />
    <!-- <Panorama :source="url1" :caption="caption" class="pano" /> -->
    <Panorama :source="url2" :caption="caption" class="pano" />
  </div>
</template>

<script>
import * as Panorama from 'vuejs-panorama';
import Header from './components/Header.vue';

export default {
  name: 'app',
  components: {
    Header,
    Panorama
  },
  data() {
    return {
      url2: 'http://peachananr.github.io/panorama_viewer/demo/demo_photo.jpg',
      caption: 'Photo by DAVID ILIFF. License: CC-BY-SA 3.0'
    };
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#app .pano {
  width: 100%;
  height: 700px;
}
</style>
